import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { WHATSAPP_URL } from './config';
import { ArrowRightIcon } from 'lucide-react';
export function CtaBanner() {
  return <section className="py-12 px-4 md:px-6" data-id="element-39">
      <div className="max-w-7xl mx-auto" data-id="element-40">
        <FadeIn data-id="element-41">
          <div className="bg-nova-dark rounded-[3rem] p-12 md:p-20 text-center relative overflow-hidden shadow-2xl" data-id="element-42">
            {/* Glow effects */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-64 bg-nova-cyan/30 filter blur-[100px] rounded-full" data-id="element-43"></div>

            <div className="relative z-10 max-w-3xl mx-auto" data-id="element-44">
              <h2 className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tight" data-id="element-45">
                Tu nueva sonrisa <br data-id="element-46" />
                <span className="text-nova-cyan" data-id="element-47">comienza hoy</span>
              </h2>
              <p className="text-xl text-gray-400 mb-10" data-id="element-48">
                Agenda tu consulta de valoración y descubre cómo la tecnología y
                el diseño pueden transformar tu vida.
              </p>

              <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-49">
                <Button href={WHATSAPP_URL} variant="primary" className="text-lg !px-10 !py-5" icon={<ArrowRightIcon size={20} data-id="element-51" />} data-id="element-50">
                  Reservar Turno Ahora
                </Button>
              </div>
              <p className="mt-6 text-sm text-gray-500" data-id="element-52">
                Respuesta rápida vía WhatsApp • Atención personalizada
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}